import BoxHeaderIcon from '../../../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import Box from '../../../../../../../components/Layout/Components/Box/Box';
import styled from 'styled-components';
import BoxHeader from '../../../../../../../components/Layout/Components/Box/Header/BoxHeader';
import { useSelector } from 'react-redux';
import PresetButton from './PresetButton';
import { darken } from 'polished';

const Categories = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Main = ({ setActiveCategory, activeCategory }) => {
  const state = useSelector((state) => state?.presets?.data);
  const toggleCategory = (categoryID) => {
    if (activeCategory === categoryID) {
      setActiveCategory(null);
    } else {
      setActiveCategory(categoryID);
    }
  };

  return (
    <Box style={{ flex: 1 }} onClick={() => setActiveCategory(null)}>
      <BoxHeader>
        <BoxHeaderIcon color={'#43a047'}>
          <div style={{ width: '30px', height: '30px', textAlign: 'center' }}>
            <HomeOutlinedIcon style={{ fontSize: '1.5em' }} />
          </div>
        </BoxHeaderIcon>
      </BoxHeader>
      <Categories>
        {state?.categories?.map((category, index) => {
          return (
            <PresetButton
              key={index}
              active={category.ID === activeCategory}
              label={category.name}
              color={darken(0.05, category.color)}
              icon={category.icon}
              onClick={(e) => {
                e.stopPropagation();
                toggleCategory(category.ID);
              }}
            />
          );
        })}
      </Categories>
    </Box>
  );
};

export default Main;
